import { render, staticRenderFns } from "./Properties.vue?vue&type=template&id=055561fc&"
import script from "./Properties.vue?vue&type=script&lang=ts&"
export * from "./Properties.vue?vue&type=script&lang=ts&"
import style0 from "./Properties.vue?vue&type=style&index=0&id=055561fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports